// extracted by mini-css-extract-plugin
export default {"to":"PostList_to__1WZ9-"};